import React from "react";

type WaroengItem = {
  id: number;
  imageUrl: string;
};

const waroengArchiveData: WaroengItem[] = [
  { id: 1, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/DSCF4562.JPG" },
  { id: 2, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_1039.JPG" },
  { id: 3, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_1075.JPG" },
  { id: 4, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_1094.JPG" },
  { id: 5, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_4408.JPG" },
  { id: 6, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_4418.JPG" },
  { id: 7, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8279.JPG" },
  { id: 8, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8281.JPG" },
  { id: 9, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8315.JPG" },
  { id: 10, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8319.JPG" },
  { id: 11, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8326.JPG" },
  { id: 12, imageUrl: "https://permikawebsite.s3.us-west-2.amazonaws.com/assets/waroeng-archives/IMG_8334.JPG" },
];

const WaroengArchive: React.FC = () => {
  return (
    <div className="bg-forest-green text-white py-16 px-4 md:px-12">
      <h2 className="text-3xl sm:text-4xl md:text-5xl text-center mb-12">
        Waroeng Archives
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {waroengArchiveData.map((item) => (
          <div
            key={item.id}
            className="overflow-hidden rounded-lg transition-transform duration-300 hover:scale-105"
          >
            <img
              src={item.imageUrl}
              alt={`Waroeng ${item.id}`}
              className="w-full h-full object-cover opacity-80 hover:opacity-100"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WaroengArchive;